var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamiconuploadimage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.50539 2.73966C4.20912 3.21444 3.7131 3.5266 3.15903 3.60534C2.84768 3.64958 2.53751 3.69747 2.22856 3.74895C1.36466 3.89291 0.75 4.65287 0.75 5.52868V12.4423C0.75 13.4619 1.57655 14.2885 2.59615 14.2885H14.9038C15.9234 14.2885 16.75 13.4619 16.75 12.4423V5.52869C16.75 4.65288 16.1353 3.89291 15.2714 3.74896C14.9625 3.69747 14.6523 3.64959 14.341 3.60534C13.7869 3.5266 13.2909 3.21445 12.9946 2.73967L12.3208 1.65986C12.0102 1.1622 11.4818 0.83893 10.8961 0.807475C10.1855 0.769322 9.47003 0.75 8.75 0.75C8.02997 0.75 7.31446 0.769322 6.60395 0.807475C6.01819 0.83893 5.48976 1.1622 5.17921 1.65986L4.50539 2.73966Z",
    stroke: "#606060",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4423 8.13462C12.4423 10.1738 10.7892 11.8269 8.75 11.8269C6.71079 11.8269 5.05769 10.1738 5.05769 8.13462C5.05769 6.09541 6.71079 4.44231 8.75 4.44231C10.7892 4.44231 12.4423 6.09541 12.4423 8.13462Z",
    stroke: "#606060",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2885 6.28846H14.2946V6.29462H14.2885V6.28846Z",
    stroke: "#606060",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamiconuploadimage);
export default __webpack_public_path__ + "static/media/camiconuploadimage.763329ff8da58f98149b60a4e7001cf9.svg";
export { ForwardRef as ReactComponent };